import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@common/components';
import { SvgHelpQuestionFill } from '@common/icon';
export const DeliveryFeeTooltip = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Tooltip theme="outlined" side="bottom" align="start" className="max-w-[25rem]" label={<div className="typo-body3 mobile-tablet:typo-caption1">상품마다 배송 조건이 달라<br />배송비가 따로 계산되어 합산돼요.</div>}><SvgHelpQuestionFill className="size-14 text-Gray-500" /></Tooltip>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};